/* global $ */

import { Controller } from 'stimulus';

function label(element) {
  if (!element) return null;

  const labelledBy = element.getAttribute('aria-labelledby');
  return document.querySelector(`#${labelledBy}`);
}

function appendError(element) {
  if (!element) return;

  const marker = document.createElement('span');
  marker.innerHTML = '❗';
  element.appendChild(marker);
}

export default class extends Controller {
  connect() {
    if (this.data.get('status') === 'done') return;
    if (this.errorPanels().length === 0) return;
    this.errorPanels().forEach((el) => {
      appendError(label(el));
    });
    $(label(this.errorPanels()[0])).tab('show');
    this.data.set('status', 'done');
  }

  panels() {
    return Array.from(this.element.querySelectorAll('[aria-labelledby]'));
  }

  errorPanels() {
    return this.panels().filter((el) => {
      const errors = Array.from(el.querySelectorAll('.is-invalid'));
      return errors.length > 0;
    });
  }
}
